import React from "react";
import Herochallenge from "./heroChallenge/Herochallenge";
import './challenge.css';

export default function Challenge() {
  return (
    <>
      <Herochallenge />
      <div className="challengesection">
        <div className="textsection">
            Track your 21 Days routine.
        </div>
        <div className="trackersection">
            <div className="trackers">
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day1</div>
                        <div className="target">Targets: 

                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day2</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day3</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day4</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day5</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day6</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day7</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day8</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day9</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day10</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day11</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day12</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day13</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day14</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day15</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day16</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day17</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day18</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day19</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day20</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tracker">
                    <div className="box">
                        <div className="day">Day21</div>
                        <div className="target">Targets: 
                        <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                            <div className="ticks">
                                <input type="checkbox" id="phone" name="phone" placeholder="Today's task" ></input>
                                <input type="text" id="phone" name="phone" placeholder="Today's task" ></input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}
